module.exports = "/assets/aa881b41954e1fbd72010f4338d08078.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2C.png
// module id = 978
// module chunks = 0